// extracted by mini-css-extract-plugin
export default {"pageContent":"styles_pageContent__sj75j","fullView":"styles_fullView__Zqbgs","shimmer":"styles_shimmer__q68z7"};